/*
 * @Date: 2020-03-09 21:30:19
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-10 21:40:59
 * @FilePath: /rongxin.web/src/views/home/about-us/index.js
 */
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import Service from './servece.js';
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        // loop: true,
        speed: 500,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      leaderList: [
        // {
        //   name: '张丹丹',
        //   job: '中农融信（北京）科技股份有限公司  董事长',
        //   descreption: '自1998年创业以来，专注农村信息化行业二十余年，资深三农领域专家。在战略规划、企业管理、资源配置、软件项目研发、市场营销以及互联网运营等方面具有深厚的资历。先后获得农村经济最有影响力人物、“地理信息产业杰出女企业家”、贵州省农业大数据专家委员会2018年特聘委员等。在“三农”信息化方面所做出的突出贡献，受到了新华社、新华网、英才杂志、证券时报、农民日报、互联网周刊、科技日报、中国电子报等媒体报道，并受邀参加CCTV-7《聚焦三农——两会特别报道》节目录制。',
        //   imgs: require('../../../assets/images/about-us/peo.png')
        // },
        // {
        //   name: '发发发',
        //   job: '中农融信（北京）科技股份有限公司  董事长',
        //   descreption: '受到了新华社、新华网、英才杂志、证券时报、农民日报、互联网周刊、科技日报、中国电子报等媒体报道，并受邀参加CCTV-7《聚焦三农——两会特别报道》节目录制。',
        //   imgs: require('../../../assets/images/about-us/peo.png')
        // }
      ]
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.getTeamList();
  },
  methods: {
    getTeamList() {
      Service.getTeamList({limit: 'unlimit', status: 1, source: 'guanWang'}).then(data => {
        this.leaderList = data.data.result;
      });
    }
  }
};
